export const RequiredAsterisk = () => (
    <span className="text-red-500 ml-0.5" title="Required">*</span>
  );